import { Helmet } from "react-helmet-async";

const SITE = "https://www.carpepel.com";

/**
 * Título, descripción, canonical, Open Graph y JSON-LD por página.
 * Cada página que llama <Seo> con sus propios valores sobrescribe el
 * default estático de public/index.html (necesario para que WhatsApp/
 * Facebook/Twitter, que no ejecutan JS, tengan algo que leer) — por eso
 * index.html solo deja ahí lo que es igual en TODAS las páginas (imagen,
 * tipo, nombre del sitio) y nada que esta función también vaya a renderizar,
 * para no terminar con dos <meta name="description"> a la vez.
 */
export default function Seo({ title, description, canonicalPath, image, schema, noindex, keywords }) {
    const canonicalUrl = canonicalPath ? `${SITE}${canonicalPath}` : undefined;
    // og:type, og:site_name, twitter:card y la imagen por defecto (DEFAULT_IMAGE)
    // ya viven en public/index.html porque son iguales en TODAS las páginas —
    // no se repiten aquí. Solo se renderiza og:image/twitter:image cuando una
    // página pasa una imagen propia (hoy, únicamente ProductDetail), que es
    // el único caso donde el default estático no sirve.
    // `schema` acepta un objeto único o un arreglo (varios tipos en la misma
    // página, ej. Product + BreadcrumbList) — un arreglo se envuelve en
    // @graph, la forma estándar de combinar varios tipos en un solo bloque
    // JSON-LD sin duplicar @context.
    const schemaBlock = Array.isArray(schema)
        ? { '@context': 'https://schema.org', '@graph': schema }
        : schema;

    return (
        <Helmet>
            {title && <title>{title}</title>}
            {title && <meta property="og:title" content={title} />}
            {description && <meta name="description" content={description} />}
            {description && <meta property="og:description" content={description} />}
            {keywords && <meta name="keywords" content={Array.isArray(keywords) ? keywords.join(', ') : keywords} />}
            {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
            {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
            {image && <meta property="og:image" content={image} />}
            {image && <meta name="twitter:image" content={image} />}
            {title && <meta name="twitter:title" content={title} />}
            {description && <meta name="twitter:description" content={description} />}
            {noindex && <meta name="robots" content="noindex, nofollow" />}
            {schemaBlock && <script type="application/ld+json">{JSON.stringify(schemaBlock)}</script>}
        </Helmet>
    );
}
